var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60018 3.99935C11.1268 3.99935 13.3802 5.41935 14.4802 7.66602C13.3802 9.91268 11.1268 11.3327 8.60018 11.3327C6.07351 11.3327 3.82018 9.91268 2.72018 7.66602C3.82018 5.41935 6.07351 3.99935 8.60018 3.99935ZM8.60018 2.66602C5.26685 2.66602 2.42018 4.73935 1.26685 7.66602C2.42018 10.5927 5.26685 12.666 8.60018 12.666C11.9335 12.666 14.7802 10.5927 15.9335 7.66602C14.7802 4.73935 11.9335 2.66602 8.60018 2.66602ZM8.60018 5.99935C9.52018 5.99935 10.2668 6.74602 10.2668 7.66602C10.2668 8.58602 9.52018 9.33268 8.60018 9.33268C7.68018 9.33268 6.93351 8.58602 6.93351 7.66602C6.93351 6.74602 7.68018 5.99935 8.60018 5.99935ZM8.60018 4.66602C6.94685 4.66602 5.60018 6.01268 5.60018 7.66602C5.60018 9.31935 6.94685 10.666 8.60018 10.666C10.2535 10.666 11.6002 9.31935 11.6002 7.66602C11.6002 6.01268 10.2535 4.66602 8.60018 4.66602Z",
    fill: "#0099D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEyeIcon);
export default __webpack_public_path__ + "static/media/blue-eye-icon.3b944160.svg";
export { ForwardRef as ReactComponent };